import Knobs from '@tencent/knobs'
import { getCookie } from '@share/utils/index'

type loginParams = {
  appid: number
  areaid: number
  returnurl: string
  auto: number
  autotime: number
  ticket: number
  unionshow: number
  popup: number
  [key: string]: string | number
}

interface CookieCheckData {
  accept: boolean
  ts: string
}
interface LoginInstanceType {
  _maskDiv: HTMLElement
  _popUpDiv: HTMLElement
}

type CheckSupport3rdpCookieCallback = (cookieEnabled: boolean) => void

const getPCLoginUrl = (params: loginParams): string => {
  const urlPrefix = import.meta.env.VITE_ENV_TYPE === 'oa' ? 'oa' : ''
  let _url = `${location.protocol}//${urlPrefix}passport.yuewen.com/?`

  for (const _key in params) {
    if ({}.hasOwnProperty.call(params, _key)) {
      _url += `${_key}=${encodeURIComponent(params[_key])}&`
    }
  }
  return _url
}
const showPCLogin = (params: loginParams): LoginInstanceType => {
  const ifrUrl = getPCLoginUrl(params)
  // 若为iframe形式的登录，则添加蒙板、append登录iframe
  let _maskDiv = document.getElementById('div_qdmask')
  if (_maskDiv) {
    _maskDiv.style.display = 'block'
  } else {
    _maskDiv = document.createElement('div')
    _maskDiv.id = 'div_qdmask'
    document.body.appendChild(_maskDiv)
  }
  let _popUpDiv = document.getElementById('qdlogin_wrap')
  if (_popUpDiv) {
    _popUpDiv.innerHTML = `<iframe id="loginIfr" src="${ifrUrl}" name="frameLG" id="frameLG" allowtransparentcy="true" width="100%" height="100%" scrolling="no" frameborder="no" allow="local-network-access"></iframe>`
    _popUpDiv.style.display = 'block'
  } else {
    _popUpDiv = document.createElement('div')
    _popUpDiv.id = 'qdlogin_wrap'
    _popUpDiv.innerHTML = `<iframe id="loginIfr" src="${ifrUrl}" name="frameLG" id="frameLG" allowtransparentcy="true" width="100%" height="100%" scrolling="no" frameborder="no" allow="local-network-access"></iframe>`
    document.body.appendChild(_popUpDiv)
  }
  return {
    _maskDiv,
    _popUpDiv,
  }
}

/**
 * 检测第三方cookie是否支持
 * @param {*} callback
 */
export const checkSupport3rdpCookie = (
  callback: CheckSupport3rdpCookieCallback,
): void => {
  const urlPrefix = import.meta.env.VITE_ENV_TYPE === 'oa' ? 'oa' : ''
  const checkDomain = `https://${urlPrefix}acts.book.qq.com`
  const now = Date.now()
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = `${checkDomain}/qd_stc/3rdp_check/?ts=${now}`

  function cleanup(): void {
    document.body.removeChild(iframe)
  }

  function handleMessages(event: MessageEvent): void {
    if (event.origin !== checkDomain) {
      return
    }
    let cookieEnabled = false

    if (event.data) {
      try {
        const data = JSON.parse(event.data) as CookieCheckData
        cookieEnabled = Boolean(
          data.accept && data.ts && data.ts === now.toString(),
        )
      } catch (e) {
        console.error(e)
      }
    }

    callback(cookieEnabled)
    cleanup()
    window.removeEventListener('message', handleMessages)
    // 移除监听后重新绑定登录弹窗的close事情的postMessage,避免无法关闭登录弹窗
  }

  iframe.onerror = cleanup

  document.body.appendChild(iframe)

  window.addEventListener('message', handleMessages)
}
const loginViaFrame = (popFrom?: string): void => {
  let loginInstance: LoginInstanceType | null = null
  // 矩阵站：不再有 qdmm（女频）独立登录回调，统一走 popup 模式直接返回当前页
  const returnurl = location.href
  const defaultparams = {
    returnurl,
    popup: 1,
    ticket: 1,
    target: 'popup',
    areaid: 1,
    appid: 10,
    auto: 1,
    autotime: 30,
    unionshow: 111111,
    version: '1.0',
    popup_from: popFrom ?? '',
  }
  loginInstance = showPCLogin(defaultparams)
  // 点击关闭按钮
  setTimeout(() => {
    function receiveMessage(event: MessageEvent<string>): void {
      const data = JSON.parse(event.data || '{}') as { action: string }
      if (data?.action === 'close' && loginInstance) {
        loginInstance._maskDiv.style.display = 'none'
        loginInstance._popUpDiv.style.display = 'none'
        loginInstance = null
        try {
          Knobs.userLogin(getCookie('ywguid') || '')
        } catch (error) {
          console.error('Knobs.userLogin failed:', error)
        }
      }
      window.removeEventListener('message', receiveMessage)
    }
    window.addEventListener('message', receiveMessage, false)
  }, 500)
}

export const login = (isUseFrame = false, popFrom = ''): void => {
  if (isUseFrame) {
    loginViaFrame(popFrom)
  } else {
    const env = import.meta.env.VITE_ENV_TYPE
    const passportUrlPrefix = env === 'oa' ? 'oa' : ''
    const currentUrl = window.location.href

    // 矩阵站：不再有 qdmm（女频）loginSuccess 中转，所有站点统一直接返回当前页
    window.location.href = `https://${passportUrlPrefix}passport.yuewen.com/?appid=10&areaid=1&auto=1&autotime=30&version=1.0&ticket=0&target=top&popup=0&source=pc&returnurl=${encodeURIComponent(
      currentUrl,
    )}`
  }
}

// PC退出登录
type loginOutParams = {
  [key: string]: string | number
}
export const loginOut = (): void => {
  let _url = '//ptlogin.qidian.com/login/logout?'
  const params: loginOutParams = {
    appid: 10,
    areaid: 6,
    source: 'pc',
    version: '1.0',
    format: 'redirect',
  }
  for (const _key in params) {
    if ({}.hasOwnProperty.call(params, _key)) {
      _url += `${_key}=${encodeURIComponent(params[_key])}&`
    }
  }
  const returnUrl = location.href
  location.href = `${_url}&returnurl=${returnUrl}`
}
